import React, { useMemo } from "react";
import { Typography } from "../../../../components";
import IdView from "../../../../components/id-view";
import { Creator } from "../../../../api/staff";
import { useTranslations } from "../../../../contexts/translation.context";

interface CreatorIdCellProps {
  creator: Creator;
}

/**
 * CreatorIdCell Component
 *
 * Displays creator ID with copy functionality and registration date
 */
const CreatorIdCell: React.FC<CreatorIdCellProps> = ({ creator }) => {
  const { t } = useTranslations();

  const createdAtDate = useMemo(() => {
    if (!creator.created_at) {
      return null;
    }

    try {
      return new Intl.DateTimeFormat(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric"
      }).format(new Date(creator.created_at));
    } catch {
      return creator.created_at;
    }
  }, [creator.created_at]);

  return (
    <div className="flex py-[8px]">
      <IdView textToCopy={creator.id}>
        {creator.id.slice(-4)}
      </IdView>
    </div>
  );
};

export default CreatorIdCell;
